export const maskEmail = (email: string): string => {
  if (!email || typeof email !== 'string') {
    return '';
  }

  const emailParts = email.split('@');
  
  if (emailParts.length !== 2) {
    return '';
  }

  const [localPart, domain] = emailParts;
  
  if (localPart.length < 2) {
    return `***@${domain}`;
  }

  const maskedLocal = localPart.substring(0, 2) + '***';
  
  return `${maskedLocal}@${domain}`;
};